import { CircularProgress, Grid, makeStyles } from '@material-ui/core';
import { FunctionComponent } from 'react';

const useStyles = makeStyles(() => ({
  root: { height: '100vh' },
}));

export const Loader: FunctionComponent = () => {
  const classes = useStyles();

  return (
    <Grid
      container
      item
      xs={12}
      justifyContent="center"
      alignItems="center"
      className={classes.root}
      data-testid="loader"
    >
      <CircularProgress color="primary" />
    </Grid>
  );
};
